import { createFlagsSchema, schema } from '@funtech-int/yango-shared';

export const featureFlagsSchema = createFlagsSchema({
    isMultiOfferEnabled: schema.boolean.optional(false),
    isNewPlayerEnabled: schema.boolean.optional(false),
    shouldShowCounterOffer: schema.boolean.optional(false),
    isPlusInfoblockEnabled: schema.boolean.optional(false),
    isWideMultiOfferDesktopEnabled: schema.boolean.optional(false),
    isYearAnnualOfferEnabled: schema.boolean.optional(false),
    isNewYearAnnualOfferEnabled: schema.boolean.optional(false),
    isPlusPaywallEnabled: schema.boolean.optional(false),
    isDesktopPremiumPaywallEnabled: schema.boolean.optional(false),
});
